import { Link } from "react-router-dom";
import { useLang } from "../i18n";
import { legalDocs } from "../i18n";
import { ArrowLeft } from "lucide-react";
import SiempriaCredit from "../components/SiempriaCredit";

export default function LegalPage({ doc }) {
  const { lang } = useLang();
  const content = (legalDocs[doc] && (legalDocs[doc][lang] || legalDocs[doc].es)) || null;
  if (!content) return null;
  return (
    <div className="min-h-screen bg-topacio-sand" data-testid={`legal-page-${doc}`}>
      <header className="bg-white border-b-2 border-topacio-ink sticky top-0 z-40">
        <div className="max-w-3xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" data-testid="legal-home-link" className="flex items-center gap-3">
            <img src="/logo-topacio.jpg" alt="Rent a Moto Topacio" className="h-10 w-auto rounded-md border-2 border-topacio-ink" />
          </Link>
          <Link to="/" data-testid="legal-back-btn"
            className="flex items-center gap-1.5 text-xs font-extrabold uppercase tracking-wider text-topacio-faded hover:text-topacio-ink transition-colors">
            <ArrowLeft className="w-4 h-4" /> {lang === "en" ? "Home" : lang === "de" ? "Startseite" : "Inicio"}
          </Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-16">
        <h1 className="font-display text-3xl sm:text-4xl tracking-tight font-black text-topacio-ink">{content.title}</h1>
        <p className="text-xs uppercase tracking-wider text-topacio-faded font-bold mt-3">{content.updated}</p>
        <div className="mt-10 space-y-8">
          {content.sections.map((s, i) => (
            <section key={i} className="card-brutal p-7">
              <h2 className="font-display text-lg font-bold text-topacio-ink">{s.h}</h2>
              <div className="mt-3 space-y-3">
                {s.ps.map((p, j) => (
                  <p key={j} className="text-sm text-topacio-faded leading-relaxed">{p}</p>
                ))}
              </div>
            </section>
          ))}
        </div>
      </main>
      <SiempriaCredit />
    </div>
  );
}
